export default __webpack_public_path__ + "static/media/Logo_Global_Retail_IFA.b0b13940.png";